import React, { useState } from 'react';
import moment from 'moment';
import { isInclusivelyBeforeDay } from 'react-dates';
import { useTranslation } from 'react-i18next';
import { CustomDateRangePicker } from './CustomDateRangePicker';
import { setIsEditingDates } from '../static/config';
import capitalizeFirst from '../util/string';

export const DateRangeFilter = ({ dateProps, onValueChange }) => {
  const { t } = useTranslation();
  const tr = (string) => capitalizeFirst(t(`studiesTable.${string.replace(/ /g, '.').toLowerCase()}`));

  const { startDate, setStartDate, endDate, setEndDate } = dateProps;
  const [focusedInput, setFocusedInput] = useState(null);

  return (
    <div key="StudyDate" className="StudiesTable_Filters_Row_Cell">
      <label>
        {tr('date')}
        <span> </span>
      </label>
      <CustomDateRangePicker
        // https://github.com/airbnb/react-dates
        startDate={startDate}
        startDateId="start-date"
        endDate={endDate}
        endDateId="end-date"
        showClearDates
        onDatesChange={(e) => {
          setStartDate(e.startDate);
          setEndDate(e.endDate);
          onValueChange('studyDateFrom', e.startDate);
          onValueChange('studyDateTo', e.endDate);
        }}
        focusedInput={focusedInput}
        onFocusChange={(updatedVal) => {
          setFocusedInput(updatedVal);
          setIsEditingDates(updatedVal);
        }}
        customArrowIcon={null}
        minimumNights={0}
        numberOfMonths={1} // For med and small screens? 2 for large?
        anchorDirection="left"
        // presets={studyDatePresets}
        hideKeyboardShortcutsPanel
        isOutsideRange={(day) => !isInclusivelyBeforeDay(day, moment())}
      />
    </div>
  );
};
